import { useMutation } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { IEmailPassword } from "../../interfaces/services";

import cookiesHelper from "../../helpers/cookies";

import { setSessionData } from "../../store/slices/global";
import api from "../apiClient";

export interface IPayload {
    creds: IEmailPassword;
    setApiError: Function;
    setIsProcessing: Function;
};

export interface IResponse {
    auth_token: string;
    email: string;
    name: string;
    role: string;
};

const useSignIn = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const mutationFn = async (data: IPayload): Promise<IResponse> => {
        const res = await api.post(`users/sign-in`, data.creds);
        return res.data;
    };

    return useMutation({
        mutationFn,
        onSuccess: (response: IResponse, variables: IPayload) => {
            if (response?.auth_token) {
                const authTokenName = process.env.REACT_APP_AUTH_TOKEN_NAME as string;
                cookiesHelper.setCookie(authTokenName, response.auth_token, (60 * 60 * 1000));
                dispatch(setSessionData({
                    email: response.email,
                    name: response.name,
                    role: response.role,
                    LMIAApplicable: true,
                }));
                navigate("/", { replace: true });
            }
        },
        onError: (error: any, variables: IPayload) => {
            variables.setApiError(error?.response?.data?.message ?? "An error occurred. Please try again.");
        },
        onSettled: (data: IResponse | undefined, error: any, variables: IPayload) => {
            variables.setIsProcessing(false);
        },
    });
};

export default useSignIn;